import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './view/inicio/inicio.component';

const routes: Routes = [
  {
    path: '',
    component: InicioComponent,
    //redirectTo: 'home',
    //pathMatch: 'full'
  },
  {
    path: 'home',
    component: InicioComponent
  },
  {
    path: 'transversal',
    loadChildren: () => import('./view/transversal/transversal.module').then(m => m.TransversalModule)
  },
  {
    path: 'general',
    loadChildren: () => import('./view/general/general.module').then(m => m.GeneralModule)
  },
  {
    path: 'form',
    loadChildren: () => import('./view/form/form.module').then(m => m.FormModule)
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
